module.exports = __webpack_public_path__ + "static/media/money-icon.b9f3e3f6.svg";